import Viewports from '../../components/fsUtils/Viewports';
import videoUtils from '../../components/fsUtils/videoUtils';

class SectionFrontVideoLoader {
    // constructor
    constructor() {

        this.viewport = new Viewports();
        //get all videos on the section front standard/regional
        this.videos = document.querySelector('.section-front-standard') ?
            document.querySelectorAll('.trending-item.is-video:nth-child(-n+9):not(.small), .trending-item.is-mpx-video') : document.querySelectorAll('.section-block .trending-item.is-video:not(.small)');
        this.loader = window.criticalVideoLoader;
        this.category = window.utag_data.category; // get category from the global utag object
        this.addClickListeners();
    }

    /**
     * Injects Video Script
     */
    addVideoScript() {
        let scrt = document.createElement('script');
        scrt.setAttribute('src', '//player.foxdcg.com/sports');
        return scrt;
    }

    addClickListeners() {
        if (this.videos) {
            for (let i = 0, j = this.videos.length; i < j; i++) {
                let video = this.videos[i];
                video.addEventListener('click', (e) => {
                    (e.preventDefault) ? e.preventDefault(): (e.returnValue = false); //ie support
                    if (!video.classList.contains('loaded')) {
                        let height = video.children[0].clientHeight; //get link height.
                        let player = video.querySelector('.sf-video-player'); //find section front video player
                        if (player) {
                            if (!player.classList.contains('platformPlayer')) {
                                video.children[0].style.display = 'none';
                                video.children[1].style.display = 'none';
                            }
                        }
                        player.classList.add('platformPlayer');
                        player.style.height = height + 'px';
                        this.videoLoader();
                        video.classList.add('loaded'); //add a tag to make sure video is already loaded
                    }
                });
            }
        }
    }

    /**
     *  Loads the video player
     */
    videoLoader() {
        let objs = [];
        if (this.loader) {
            //get video players of the page. 
            objs = this.loader.getVideoElementsData().map((data) => {
                return data;
            });
        }
        if (typeof FDM_Player !== 'undefined') {
            this.loader.loadVideos(FDM_Player, objs);
        } else {
            this.loader.loadScript(this.loader.loadVideos.bind(this.loader), objs);
        }
    }

} // Section Front Video Loader

export default SectionFrontVideoLoader;


// WEBPACK FOOTER //
// ./assets/components/platformPlayer/SectionFrontVideoLoader.js